import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, Row, Col,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import Select from 'react-select';
import { AuthContext } from '../../context/AuthContext';

import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import { UpdateFormaPagamentoType } from '../../context/hooks/useFormaPagamento';

import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    formaPagamento: UpdateFormaPagamentoType | null;
    onUpdated?: () => void;
}

export const EditFormaPagamentoModal: React.FC<Props> = ({ isOpen, toggle, formaPagamento, onUpdated }) => {
    const { updateFormaPagamento } = useContext(FormaPagamentoContext);
    const { objUserTk } = useContext(AuthContext);

    const [form, setForm] = useState<UpdateFormaPagamentoType | null>(null);

    useEffect(() => {
        if (isOpen && formaPagamento) setForm({ ...formaPagamento });
    }, [isOpen, formaPagamento]);

    if (!form) return null;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm(prev => prev ? { ...prev, [name]: value } : prev);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!form) return;
        const ok = await updateFormaPagamento({
            ...form,
        });
        if (ok) {
            onUpdated?.();
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Editar informações da forma de pagamento</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label">Forma de pagamento</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    placeholder="Forma de pagamento"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Link do gateway</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="linkGateway"
                                    value={form.linkGateway || ''}
                                    onChange={onChange}
                                    placeholder="Link do gateway"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Token</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="token"
                                    value={form.token || ''}
                                    onChange={onChange}
                                    placeholder="Token de autenticação"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">Salvar alterações</Button>
                        <Button style={{ background: '#585858', color: '#fff' }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default EditFormaPagamentoModal;